import React from 'react';

// @components
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import { AlertDetailsList } from 'pages/Alerts/components/AlertsDetails/components/AlertDetailsList';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import ActionsYouCanTake from '../../components/ActionsYouCanTake/ActionsYouCanTake';
import { Row } from 'components/Containers/Row/Row';
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions/FrequentlyAskedQuestions';
import { getPlaceholderValue } from 'helpers/alerts.helpers';

// @helpers
import { searchGoalModule } from 'helpers/goals.helpers';
import { ConditionalRendering } from 'helpers/conditionalRedering.helper';

// @constants
import {
  DEBT_RELIEF_VERTICAL,
  PERSONAL_LOAN_VERTICAL,
} from 'types/mrph.vertical.constants';

// @images
import AccountImprovedImage from 'style_assets/notificationsAlerts/account-improved.png';

import { useConfig } from 'hook/config.hook';

const AccountImprovedNotificationView = props => {
  const { alertDetailsConfig } = props;
  const placeholder = getPlaceholderValue(
    alertDetailsConfig?.alertDetailsList,
    'Status',
  );

  const { config } = useConfig();

  const frequentlyAskedQuestion =
    config?.notificationAlerts?.accountImproved?.faq;

  const onlyCS = config?.notificationAlerts?.accountImproved?.ActionsYouCanTake;

  const description = placeholder
    ? `This account is now ${placeholder?.toLowerCase() ?? ''}`
    : '';

  const actionsToTakeFiltered = [];

  const actionsYouCanTake =
    config?.notificationAlerts?.accountImproved?.action?.actionsYouCanTake;

  if (Array.isArray(actionsYouCanTake)) {
    actionsYouCanTake.forEach(actionToTake => {
      let hasActionToTake = false;
      if (actionToTake?.takeAction?.module) {
        hasActionToTake = true;
        const moduleSearch = searchGoalModule(
          props?.goals,
          actionToTake?.takeAction?.module,
        );
        if (moduleSearch?.name) {
          actionsToTakeFiltered.push({ ...actionToTake });
        }
      }
      if (!hasActionToTake) {
        actionsToTakeFiltered.push(actionToTake);
      }
    });
  }

  return (
    <SectionContainer className="cmAlertsDetailsContainer notificationsAlertsDetails">
      <Row className="text-28 fontLatoNormal700 margB16">
        <Label type="H4" typeHeader={'h4'}>
          {alertDetailsConfig.title}
        </Label>
      </Row>

      <Row>
        <FlexContainer column>
          <Label className="caption system_neutral_n300_text">
            {`Reported on ${props.alertDetailsConfig?.date} ${
              config?.notificationAlerts?.accountImproved
                ?.phxAccountImprovementAlert
                ? 'to'
                : 'by'
            } `}
            {props?.bureauLogo[props.selectedAlertDetails?.bureau]}
          </Label>
          <div>
            <img
              className="margt20 width-127px"
              src={AccountImprovedImage}
              alt="Account Improved"
            />
          </div>
          <Label className="text-16 fontLatoNormal600">{description}</Label>
          <Label type="Body1" className="margT16 mBody-2">
            {config?.notificationAlerts?.accountImproved?.subTitle}
          </Label>
          <AlertDetailsList
            alertDetailsList={alertDetailsConfig?.alertDetailsList}
            lineType={alertDetailsConfig?.lineType}
            datatestid={`${props.datatestid}-detailList`}
            outerClass={'padB0 margT16'}
          />
        </FlexContainer>
      </Row>
      <div className="padTB4 bgGrey005"></div>
      {onlyCS && (
        <ConditionalRendering isTrue={actionsToTakeFiltered.length > 0}>
          <Row>
            <ActionsYouCanTake
              {...props}
              title={config?.notificationAlerts?.accountImproved?.action?.title}
              subTitle={
                config?.notificationAlerts?.accountImproved?.action?.subTitle
              }
              actionsYouCanTake={actionsToTakeFiltered}
            />
          </Row>
          <div className="padTB4 bgGrey005"></div>
        </ConditionalRendering>
      )}
      {config?.notificationAlerts?.accountImproved
        ?.showPhxAccountImprovedDisclaimer && (
        <Row>
          <Label type="Body1" className="margT16 italic">
            {
              config?.notificationAlerts?.accountImproved
                ?.accountImprovedDisclaimer
            }
          </Label>
        </Row>
      )}
      <Row className="padt20">
        <FrequentlyAskedQuestions
          frequentlyAskedQuestion={frequentlyAskedQuestion}
        />
      </Row>
    </SectionContainer>
  );
};

export default AccountImprovedNotificationView;
